'use strict';

import { assignDeep, GSAPAnimationMixer, settingsData, threeJsVariables } from '../../settings';
import { Box3, Box3Helper, Vector3 } from 'three';
import { ViewMode } from '../../common';
import gsap from 'gsap';

const DEFAULT_PARAMS = {
  active: false,
  scalar: 0
};

export class CameraCollision {
  static scope = null;
  static prevent = false;

  constructor () {
    this.params = assignDeep(DEFAULT_PARAMS,config.threejs.cameraCollision || {});
    this.camera = threeJsVariables.perspectiveCamera;
    this.orbitControls = threeJsVariables.orbitControls;
    this.box = new Box3();
    this.isBounce = false;
    this.position = new Vector3();
    this.target = new Vector3();
    CameraCollision.scope = this;
  }

  checkCollision() {
    if (!this.params.active) return;
    if (this.box.containsPoint(this.camera.position) && !this.isBounce) {
      this.box.clampPoint(this.camera.position,this.position);
      this.bounce();
    }
  }

  bounce() {
    this.isBounce = true;
    this.target.subVectors(this.position,this.orbitControls.target).normalize().setLength(5).add(this.position);
    this.camera.position.copy(this.target);
    this.orbitControls.update();
    this.isBounce = false;

    // gsap.to(this.camera.position,{
    //   x: this.target.x,
    //   y: this.target.y,
    //   z: this.target.z,
    //   ease: GSAPAnimationMixer.ease,
    //   duration: 0.5,
    //   onComplete: () => this.isBounce = false
    // });

  }

  addObject(object) {
    const box = new Box3();
    box.setFromObject(object,true).expandByScalar(this.params.scalar);
    this.box.union(box);
  }

  static checkCollision() {
    if (CameraCollision.scope && settingsData.activeViewMode === ViewMode.Orbit && !CameraCollision.prevent) {
      CameraCollision.scope.checkCollision();
    }
  }

}
